function markNotificationRead(params: { notificationId: number }) {
    return window.apiCoreSingleton.get(`/api/admin/system/notification/read/id/${params.notificationId}`);
}

function markAllNotificationsRead() {
    return window.apiCoreSingleton.get(`/api/admin/system/notification/read/all`);
}

export { markNotificationRead, markAllNotificationsRead };
